import {Component, Input} from '@angular/core';
import {ConceptsContainer} from '../../../core/definitions/concepts-container';

@Component({
    selector: 'app-admin-list',
    templateUrl: './admin-list.component.html',
    styleUrls: ['./admin-list.component.scss'],
    standalone: false
})
export class AdminListComponent {
  @Input() conceptsContainer: ConceptsContainer;
  @Input() menuTitle: string;

  onSearchParamChange() {
    this.conceptsContainer.reload = Math.random();
  }

  get selected() {
    let res = '';
    if (this.conceptsContainer.selected.length) {
      res = this.conceptsContainer.selected.length + ' / ';
    }
    return res;
  }

}
